import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EncrDecrService } from '@mysrc/app/Providers/EncrDecrService';
import { BaseHttpReqRespService } from '@mysrc/app/modules/fwcore/services/base-http-req-resp.service';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { Observable } from 'rxjs';
import { question } from '../models/question.model';
import { CommonService } from './commonservice';
import { API_ENDPOINTS } from '../../../api-endpoints';

@Injectable()
export class QuestionService extends BaseHttpReqRespService {
  myAppUrl: any;
  hostName: "";
  public headers!: Headers;
  QUESTION_ENDPOINT = API_ENDPOINTS.QUESTION;
  constructor(http: HttpClient
    , @Inject(OKTA_AUTH) private oauth: OktaAuth
    , private EncrDecr: EncrDecrService
    , private commonService: CommonService
    , @Inject('CONFIG_SETTINGS') configSettings: any) {
    super(http, oauth);
    const genSettings = configSettings[<any>'general'];
    this.baseUrl = genSettings[<any>'adminApiUrl'];
    this.apiKey = genSettings[<any>'apiKey'];
    this.myAppUrl = this.baseUrl;
    this.hostName = genSettings[<any>'hostName'];;

  }



  getAccessToken(): Observable<any> {
    return this.commonService.httpGet("", this.myAppUrl + '/' + this.QUESTION_ENDPOINT.GET_TOKEN);

  }

  ImportNew(): Observable<question> {
    // Ensure the URL is constructed correctly with a single slash between segments
    const url = [
      this.myAppUrl,
      this.QUESTION_ENDPOINT.IMPORT_NEW_QUESTION_LIST
    ].map(segment => segment.toString().replace(/(^\/+|\/+$)/g, '')).join('/');
    return this.commonService.httpGet("", url);
  }
  copyQuestion(data: any, folderId: any): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    const workspaceId = this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '0');
    const userId = this.EncrDecr.get(localStorage.getItem('userId') ?? '');

    var queryString = "?workspaceId=" + workspaceId + "&userId=" + userId + "&folderId=" + folderId;
    return this.http.post<any>(this.myAppUrl + '/' + this.QUESTION_ENDPOINT.COPY + queryString, data, options);
  }

  getMainQuestionList(folderId: string = '0'): Observable<any> {

    //let workspaceId = this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '0');
    let hostName = this.hostName;
    let queryString = '?folderId=' + folderId + '&hostName=' + hostName;
    var url = `${this.myAppUrl}/${this.QUESTION_ENDPOINT.MAIN_QUESTION_LIST}${queryString}`;
    return this.commonService.httpGet("", url);
  }
  removeQuestionListCache(): Observable<any> {
    var url = `${this.myAppUrl}/${this.QUESTION_ENDPOINT.CLEAR_QUESTION_LIST_CATCHE}`;
    return this.commonService.httpGet("", url);
  }

  saveFolder(folderForm: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      params: {
        userId: this.EncrDecr.get(localStorage.getItem('userId') ?? ''),
        workspaceId: this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '')
      }
    };
    return this.http.post<any>(this.myAppUrl + '/' + this.QUESTION_ENDPOINT.SAVE_FOLDER, folderForm, httpOptions);
  }

  saveQuestion(questionForm: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=UTF-8',
      })
      //,params: {
      //  workspaceId: this.EncrDecr.get(localStorage.getItem('workspaceId') ?? ''),
      //  userId: this.EncrDecr.get(localStorage.getItem('userId') ?? '')
      //}
    };
    let workspaceId = this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '');
    let userId = this.EncrDecr.get(localStorage.getItem('userId') ?? '');

    return this.http.post<any>(this.myAppUrl + '/' + this.QUESTION_ENDPOINT.SAVE + '/' + workspaceId + '/' + userId, questionForm, httpOptions);
  }
  getExportQuestion(folderId: any, questionIds: any): Observable<any> {
    // Use POST to avoid URL length limits when exporting many questions
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    const body = {
      folderId: folderId.toString(),
      questionIds: questionIds
    };
    return this.http.post<any>(`${this.myAppUrl}/${this.QUESTION_ENDPOINT.QUESTIONS_TO_EXPORT}`, body, httpOptions);
  }

  deleteQuestion(model: string): Observable<any> {
    return this.commonService.httpGet(
      "", this.myAppUrl + '/' + this.QUESTION_ENDPOINT.DELETE + '/' + model
    );
  }


  getEditFolder(parameter: string): Observable<any> {
    return this.commonService.httpGet(
      "", this.myAppUrl + '/' + this.QUESTION_ENDPOINT.EDIT_FOLDER + '/' + parameter
    );

  }
  getFolderList(workSpaceid: string): Observable<any> {
    return this.commonService.httpGet(
      "", this.myAppUrl + '/' + this.QUESTION_ENDPOINT.FOLDER_LIST + '/' + workSpaceid
    );
  }

  copyFolder(copyFolderForm: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      params: {
        userId: this.EncrDecr.get(localStorage.getItem('userId') ?? ''),
        workspaceId: this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '')
      }
    };
    return this.http.post<any>(this.myAppUrl + '/' + this.QUESTION_ENDPOINT.COPY_FOLDER, copyFolderForm, httpOptions);
  }

}
